// Module
var code = "<div class=\"cv\">\r\n    <span data-id=\"cv\" class=\"cvNumber\"></span><span data-id=\"cvName\" class=\"cvName\"></span><input data-id=\"value\" type=\"text\" inputmode=\"numeric\" maxlength=\"3\"><div class=\"led\"></div>\r\n</div>";
// Exports
export default code;